const BASE_URL ="https://www.googleapis.com/oauth2/v1/";

export default {BASE_URL}